import { VARIANT_PRICING_TYPE } from "./invoicing-and-payments.js";
export var LOCATION_TYPE;
(function (LOCATION_TYPE) {
    LOCATION_TYPE["REGULAR"] = "REGULAR";
    LOCATION_TYPE["AFFILIATE"] = "AFFILIATE";
    LOCATION_TYPE["AREA_BASED"] = "AREA_BASED";
    LOCATION_TYPE["TEMPORARY"] = "TEMPORARY";
})(LOCATION_TYPE || (LOCATION_TYPE = {}));
export const LOCATION_TYPE_OPTIONS = {
    [LOCATION_TYPE.REGULAR]: {
        id: LOCATION_TYPE.REGULAR,
        label: "Regular",
    },
    [LOCATION_TYPE.AFFILIATE]: {
        id: LOCATION_TYPE.AFFILIATE,
        label: "Affiliate",
    },
    [LOCATION_TYPE.AREA_BASED]: {
        id: LOCATION_TYPE.AREA_BASED,
        label: "Area Based",
    },
    [LOCATION_TYPE.TEMPORARY]: {
        id: LOCATION_TYPE.TEMPORARY,
        label: "Temporary",
    },
};
export const LOCATION_BILLING_TYPE = {
    DEFAULT: {
        label: "Default",
        value: VARIANT_PRICING_TYPE.DEFAULT,
    },
    REGIONAL: {
        label: "Regional",
        value: VARIANT_PRICING_TYPE.REGIONAL,
    },
    AFFILIATE: {
        label: "Affiliate",
        value: VARIANT_PRICING_TYPE.AFFILIATE,
    },
};
//# sourceMappingURL=location.js.map